<!-- 特典を探す 特大カテゴリ選択 -->
<template>
  <div class="crly-m-common-search-keyword-category">
    <template v-for="(cat, index) in CONST.CATEGORY_TYPE">
      <CrlyAtomsCommonSearchKeywordCategoryBtn
        :key="index"
        :category="cat"
        :active="activeCat"
        @clickCatBtn="clickCatBtn"
      />
    </template>
  </div>
</template>

<script>
import CrlyAtomsCommonSearchKeywordCategoryBtn from "@crly/components/atoms/common/search/keyword/CategoryBtn.vue";

export default {
  name: "CrlyMoleculesCommonSearchKeywordCategory",
  components: {
    CrlyAtomsCommonSearchKeywordCategoryBtn
  },
  data() {
    return {
      /**
       * 選択中のカテゴリ
       */
      activeCat: 1
    };
  },
  methods: {
    /**
     * カテゴリクリックイベント
     * @param {Number} category 選択されたカテゴリ
     */
    clickCatBtn(category) {
      this.activeCat = category;
      this.$emit("changeActiveCategory", category);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/search/keyword/category.scss";
</style>
